<template>
    <div>
        <v-dialog v-model="dialog" max-width="650">
            <LabeledCard :label="$t('Фильтрация')">
                <slot :filterData="filterData" />
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" sm="6"></v-col>
                        <v-col cols="12" sm="3">
                            <v-btn @click="handleCancel" outlined :color="$vuetify.theme.themes.dark.primary" class="rounded-btn w100">{{
                                $t('Отмена')
                            }}</v-btn>
                        </v-col>
                        <v-col cols="12" sm="3" class="d-flex justify-end">
                            <v-btn @click="handleSubmit" dark class="rounded-btn w100" :color="$vuetify.theme.themes.dark.primary">{{ $t('Применить') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </LabeledCard>
        </v-dialog>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" class="mr-1" @click="dialog = true">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon color="red" :disabled="customDisableEnabled ? customDisable : clearDisabled" @click="handleClear">
            <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { isObjectEmpty, cloneObject } from '@/utils';
import LabeledCard from '@/components/ui/LabeledCard';

export default {
    props: ['value', 'customDisableEnabled', 'customDisable', 'hasError'],
    components: {
        LabeledCard
    },
    data() {
        return {
            dialog: false,
            filterData: {}
        };
    },
    watch: {
        value() {
            this.filterData = cloneObject(this.value);
        }
    },
    computed: {
        clearDisabled() {
            return isObjectEmpty(this.value);
        }
    },
    methods: {
        handleClear() {
            this.filterData = {};
            this.$emit('input', {});
            this.$emit('clearFilter');
        },
        handleSubmit() {
            if (this.hasError) return;
            this.$emit('input', cloneObject(this.filterData));
            this.$emit('filterItems', cloneObject(this.filterData));
            this.dialog = false;
        },
        handleCancel() {
            this.dialog = false;
            this.filterData = this.value;
        }
    },
    created() {
        this.filterData = cloneObject(this.value);
    }
};
</script>
<style></style>
